import {
  CreditApplicationStatus,
  useCreditClient
} from '../../../../services/credit';
import { CreditApplicationScreen } from '..';

const creditApplicationClient = useCreditClient();

export function getPlanNameText(planName) {
  switch (planName) {
    case 'invest':
      return 'Greenlight + Invest';
    case 'max':
      return 'Greenlight Max';
    case 'infinity':
      return 'Greenlight Infinity';
    default:
      return 'Greenlight Core';
  }
}

export function getSavingsReward(planName) {
  switch (planName) {
    case 'max':
      return '2';
    case 'infinity':
      return '5';
    default:
      return '1';
  }
}

export function getCreditApplicationScreen() {
  if (!creditApplicationClient.hasActiveCreditApplication()) {
    return CreditApplicationScreen.BeginApplication;
  }
  if (!creditApplicationClient.hasSubmittedHousingInformation()) {
    return CreditApplicationScreen.HousingInformation;
  }
  if (!creditApplicationClient.hasSubmittedEmploymentInformation()) {
    return CreditApplicationScreen.IncomeInformation;
  }
  if (
    creditApplicationClient.applicationStatus ===
    CreditApplicationStatus.APPROVED
  ) {
    return CreditApplicationScreen.Approved;
  }
  if (
    creditApplicationClient.applicationStatus ===
    CreditApplicationStatus.REJECTED
  ) {
    return CreditApplicationScreen.Denied;
  }
  if (
    creditApplicationClient.applicationStatus ===
    CreditApplicationStatus.ACCEPTED
  ) {
    return CreditApplicationScreen.Delayed;
  }
  if (!creditApplicationClient.hasAcceptedPreApprovalDocs()) {
    return CreditApplicationScreen.PreTerms;
  }
  return CreditApplicationScreen.BeginApplication;
}
